import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { JobModels } from '@models/job.models';
import { JobActions } from '@states/jobs/job.action-types';
import { cleanRemovingId, removeJobSuccess, setQueues } from '@states/jobs/job.actions';
import { Dictionary } from '@ngrx/entity/src/models';


export interface JobState extends EntityState<JobModels.Document> {
  initialLoaded: boolean;// show loader until first loading happening
  notEmpty: boolean; //show no Data if result empty
  listLoading: boolean; //show loaded each time when query params changed,

  /**
   * Paging required
   */
  latestTs: number;
  isLastPage: boolean;
  queues: string[];

  removingIds: Dictionary<boolean>;

}

export const jobAdapter: EntityAdapter<JobModels.Document> = createEntityAdapter<JobModels.Document>({
  selectId: (document: JobModels.Document) => document.id,
});

const initialState: JobState = jobAdapter.getInitialState({
  initialLoaded: false,
  notEmpty: false,
  listLoading: false,

  latestTs: null,
  isLastPage: false,
  queues: [],
  removingIds: {},
});

export const { selectAll, selectEntities, selectIds, selectTotal } = jobAdapter.getSelectors();


export const jobStateReducer = createReducer(
  initialState,
  on(JobActions.resetToInitialState, state => {
    return {
      ...initialState,
    };
  }),
  on(JobActions.setListLoader, (state, { loading }) => {
    return {
      ...state,
      listLoading: loading,
    };
  }),
  on(JobActions.getJobsSuccess, (state, { documents }) => {
    return jobAdapter.setMany(documents, { ...state });
  }),
  on(JobActions.setQueues, (state, { queues }) => {
    return {
      ...state,
      queues,
    };
  }),
  on(JobActions.removeJob, (state, { jobId }) => {
    const removingIds = { ...state.removingIds };
    removingIds[jobId] = true;
    return {
      ...state,
      removingIds,
    };
  }),
  on(JobActions.removeJobSuccess, (state, { jobId }) => {
    const removingIds = { ...state.removingIds };
    removingIds[jobId] = true;
    return jobAdapter.removeOne(jobId, {
      ...state,
      removingIds,
    });
  }),
  on(JobActions.cleanRemovingId, (state, { jobId }) => {
    const removingIds = { ...state.removingIds };
    delete removingIds[jobId];
    return {
      ...state,
      removingIds,
    };
  }),
);

